import { useState } from 'react';
import formValidationController from '../controllers/formValidationController';
import { languageController } from '../controllers/language/languageController';

// Custom hook to handle general form actions
export const useForm = ({
  initState,
  validations,
  onSubmit
}) => {
  const [data, setData] = useState(initState);
  const [errors, setErrors] = useState({});

  // Handle form element changes
  const handleChange = (event) => {
    const { name, value } = event.target;
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validations) {
      let valid = true;
      const newErrors = {};

      for (const element in validations) {
        const value = data[element];
        const patterns = validations[element];
        const isRequired = patterns.includes('required');

        // If it's not 'required' and value is empty, skip the validations on it.
        if (!isRequired && !value) continue;

        // Loop through validations on that element.
        for (const pattern of patterns) {
          // Terminate the loop as soon as the current validation in the loop is false. 
          if (pattern && !formValidationController.validateField(value, pattern)) {
            valid = false;
            newErrors[element] = languageController.getError(pattern);
            break;
          }
        }
      }

      if (!valid) {
        setErrors(newErrors);
        return;
      }
    }

    // Initialize states
    setErrors({});

    // Run onSubmit after validation
    if (onSubmit) {
      onSubmit();
    }
  };

  return {
    data,
    handleChange,
    handleSubmit,
    errors,
    setData
  };
};